import { get_datastring, createNewDate, get_DateFirebase } from "../../APIs/date";
import { modelAnalytics } from "../../../Models/analytics/analytics";
import { element } from "svelte/internal";
import { Timestamp } from "firebase/firestore";

export class servicioMesa {

    index;
    service;
    config;
    dataView
    dataListService
    model_Analytics = new modelAnalytics();

    constructor(service, index, dataView) {
        this.service = service;
        this.index = index;
        this.dataListService = this.service.listRatinggs[this.index]
        /* this.reset(this.service.listRatinggs[this.index].config); */
        this.dataView = dataView;

    }

    firebaseLikeId() {
        const chars = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
        let id = '';
        let now = Date.now();

        // parte de tiempo (8 chars)
        for (let i = 7; i >= 0; i--) {
            id = chars[now % 64] + id;
            now = Math.floor(now / 64);
        }
        // parte random (12 chars)
        for (let i = 0; i < 12; i++) {
            id += chars[Math.floor(Math.random() * 64)];
        }
        return id;
    }

    async validDataMes() {
        let date = await createNewDate("America/Mexico_City");
        

/*         let get_data_save = await this.model_Analytics.obtenerDatos({
            id: '-OqN-HbhTK7g_Qooswr9',
            y: "2026",
            m: "5"
        });

        if (get_data_save.status) {
            
            await this.model_Analytics.Crear({
                id: '-OpDtwPM0xkT5RjY4C3l',
                y: "2026",
                m: "5",
                data: get_data_save.data.coleccion
            });
        }

        if (date.status == false) {
            return false;
        } */

        if (!this.dataListService.hasOwnProperty('analytics')) {
            this.dataListService.analytics = {
                coleccion: [],
                idDoc: this.firebaseLikeId(),
                date: await date.currentDate
            }
            this.service.listRatinggs[this.index] = this.dataListService;

        }
        return this.service;
    }

    async setAnalytics() {
        let date = await createNewDate("America/Mexico_City");
        let set_data = true;
        if (this.dataListService.analytics.coleccion.length == 0) {
            return this.service;
        }

        const date1 = get_DateFirebase(date.currentDate);

        let blockData = [];

        for (const [key, property] of Object.entries(this.dataListService.analytics.coleccion.reduce(
            (acc, blockdata) => {
                if (!blockdata.date.hasOwnProperty('seconds')) {
                    const convert = Timestamp.fromDate(blockdata.date);
                    blockdata.date = convert;
                }
                if (!acc[new Date(blockdata.date.seconds * 1000).getFullYear()]) acc[new Date(blockdata.date.seconds * 1000).getFullYear()] = [];

                if (!acc[new Date(blockdata.date.seconds * 1000).getFullYear()][new Date(blockdata.date.seconds * 1000).getMonth() + 1]) acc[new Date(blockdata.date.seconds * 1000).getFullYear()][new Date(blockdata.date.seconds * 1000).getMonth() + 1] = [];

                acc[new Date(blockdata.date.seconds * 1000).getFullYear()][new Date(blockdata.date.seconds * 1000).getMonth() + 1].push(blockdata);
                return acc;
            },
            {},
        ))) {
            for (const elementmes of property) {

                if (elementmes) {
                    const fdate = elementmes[0].date.toDate();
                    const pyear = fdate.getFullYear();
                    const pmonth = fdate.getMonth() + 1;


                    if (pmonth == date.currentDate.getMonth() + 1 && pyear == date.currentDate.getFullYear() && set_data) {
                        this.service.listRatinggs[this.index].analytics.coleccion = elementmes;


                        return this.service;
                    }

                    let get_data = await this.model_Analytics.obtenerDatos({
                        id: this.dataListService.analytics.idDoc,
                        y: pyear.toString(),
                        m: pmonth.toString()
                    });


                    if (!get_data.status) {
                        //nuevo
                        await this.model_Analytics.Crear({
                            id: this.dataListService.analytics.idDoc,
                            y: pyear.toString(),
                            m: pmonth.toString(),
                            data: elementmes
                        });
                    }

                    if (get_data.status) {

                        elementmes.forEach((element, idx) => {
                            if (get_data.data.coleccion.filter(item => item.date == element.date).length == 0) {
                                get_data.data.coleccion.push(element)

                            }

                        });

                        /* if(pmonth == date.currentDate.getMonth() + 1 && pyear == date.currentDate.getFullYear()){
                            this.service.listRatinggs[this.index].analytics.coleccion = get_data.data.coleccion;
                        } */

                        set_data = await this.model_Analytics.Crear({
                            id: this.dataListService.analytics.idDoc,
                            y: pyear.toString(),
                            m: pmonth.toString(),
                            data: get_data.data.coleccion
                        });


                    }

                }

            }
        }

        return this.service;

    }


    newData(data) {

        if (!this.dataView.ind_user) {
            /* console.log(this.service.listRatinggs[this.index].analytics.coleccion); */

            this.service.listRatinggs[this.index].analytics.coleccion.push(data);

            this.dataView.ind_user = this.service.listRatinggs[this.index].analytics.coleccion.length - 1;
        }
    }

    saveData(data) {
        this.service.listRatinggs[this.index].analytics.coleccion[this.dataView.ind_user].listServices.push(data);
        this.service.listRatinggs[this.index] = this.dataListService;
        return this.service
    }

    upd_service(newService) {
        this.dataListService = this.service.listRatinggs[this.index];
        this.service = newService;
    }

    getService() {
        return this.service;
    }

    async setTimeMes(index) {
        let date = await createNewDate("America/Mexico_City");

        this.service.service.mesasService[index - 1].status = true;
        this.service.service.mesasService[index - 1].service.status = true;
        this.service.service.mesasService[index - 1].service.date = date.currentDate;

        if (
            this.service.listRatinggs[this.dataView.listindex].config.login
        ) {
            this.service.service.mesasService[index - 1].dataUser = {
                status: true,
                displayName: $user.displayName,
                photoURL: $user.photoURL,
            };
        } else {
            this.service.service.mesasService[index - 1].dataUser = {
                status: false,
                displayName: "",
                photoURL: ""
            };
        }

    }

    async stopTimeMes(index) {
        let date = await createNewDate("America/Mexico_City");
        this.service.service.mesasService[
            index - 1
        ].service.status = false;

        this.service.service.mesasService[index - 1].cuenta.status =
            false;
    }

    async returnDate() {
        let date = await createNewDate("America/Mexico_City");
        return date.currentDate
    }


}